// Module
var code = "<form v-if=\"atsLoginForm != null\" @submit.stop.prevent=\"login()\" class=\"inline\"> <button data-id=\"ats-login-btn\" :disabled=\"loggingIn\" class=\"text-indigo-700 bg-white\">{{ loggingIn ? 'Logging In...' : buttonLabel }} &#187;</button> </form> ";
// Exports
export default code;